(function () {
  var cartEl = document.querySelector('[data-lp-cart]');
  if (!cartEl || window.LPCart) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var moneyFormat = cartEl.dataset.moneyFormat || '${{amount}}';
  var lastCart = null;
  var protId = cartEl.dataset.protId || '';
  var protDefault = cartEl.dataset.protDefault !== 'false';
  var protKey = 'lpProtOff';
  var syncing = false;
  function protOff() { try { return localStorage.getItem(protKey) === '1'; } catch (e) { return false; } }
  function setProtOff(v) { try { if (v) localStorage.setItem(protKey, '1'); else localStorage.removeItem(protKey); } catch (e) {} }
  function isProt(it) { return protId && String(it.variant_id) === String(protId); }

  function formatMoney(cents, format) {
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount';
    function fmt(n, dec, th, ds) {
      n = (n / 100).toFixed(dec);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (parts[1] ? ds + parts[1] : '');
    }
    var v;
    switch (kind) {
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function money(c) { return formatMoney(c, moneyFormat); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  function notifyTheme(cart) {
    try {
      var ev = new Event('shopify:cart:lines-update', { bubbles: true });
      var n = cart.item_count - protQty(cart);
      ev.promise = Promise.resolve({ cart: { totalQuantity: n }, detail: { itemCount: n } });
      document.dispatchEvent(ev);
    } catch (e) {}
  }

  function protQty(cart) { var q = 0; cart.items.forEach(function (it) { if (isProt(it)) q += it.quantity; }); return q; }
  function fetchCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeLine(line, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); });
  }
  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function render(cart) {
    lastCart = cart;
    notifyTheme(cart);
    var box = cartEl.querySelector('[data-lp-cart-items]');
    var shown = cart.item_count - protQty(cart);
    cartEl.querySelector('[data-lp-cart-count]').textContent = '(' + shown + ')';
    cartEl.querySelector('[data-lp-cart-subtotal]').textContent = money(cart.total_price);
    if (!shown) {
      box.innerHTML = '<div class="lp-cart__empty">' + esc(cartEl.dataset.empty || 'Your cart is empty') + '</div>';
    } else {
      var lines = cart.items.map(function (it, i) { return { it: it, line: i + 1 }; }).filter(function (pl) { return !isProt(pl.it); });
      lines.sort(function (a, b) { return b.it.final_line_price - a.it.final_line_price; });
      box.innerHTML = lines.map(function (pl) {
        var it = pl.it;
        var v = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=180' : '';
        var orig = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        return '<div class="lp-cart__item" data-line="' + pl.line + '">' +
          (img ? '<a href="' + esc(it.url) + '"><img class="lp-cart__itimg" src="' + esc(img) + '" alt=""></a>' : '<span class="lp-cart__itimg"></span>') +
          '<span class="lp-cart__itmid"><b>' + esc(it.product_title) + '</b>' + (v ? '<em>' + esc(v) + '</em>' : '') +
          '<span class="lp-cart__qty"><button type="button" data-lp-q="' + pl.line + '" data-d="-1" aria-label="Decrease">&minus;</button><span>' + it.quantity +
          '</span><button type="button" data-lp-q="' + pl.line + '" data-d="1" aria-label="Increase">+</button></span></span>' +
          '<span class="lp-cart__itright"><b>' + money(it.final_line_price) + '</b>' + orig +
          '<button type="button" class="lp-cart__remove" data-lp-q="' + pl.line + '" data-d="0">' + esc(cartEl.dataset.remove || 'Remove') + '</button></span></div>';
      }).join('');
    }
    var ups = cartEl.querySelector('[data-lp-cart-upsell]'), uid = cartEl.dataset.upsellId;
    if (ups && uid) {
      var has = cart.items.some(function (it) { return String(it.variant_id) === String(uid); });
      ups.hidden = has || !shown;
      if (!ups.dataset.ready) {
        ups.dataset.ready = '1';
        cartEl.querySelector('[data-lp-up-img]').src = cartEl.dataset.upsellImg || '';
        cartEl.querySelector('[data-lp-up-title]').textContent = cartEl.dataset.upsellTitle || '';
        cartEl.querySelector('[data-lp-up-price]').textContent = cartEl.dataset.upsellPrice || '';
      }
    }
    sync(cart);
  }

  function renderProt(cart) {
    var row = cartEl.querySelector('[data-lp-prot]');
    if (!row) return;
    var shown = cart.item_count - protQty(cart);
    row.hidden = !shown;
    row.removeAttribute('aria-busy');
    var cb = row.querySelector('[data-lp-prot-cb]');
    if (cb) cb.checked = protQty(cart) > 0;
  }

  /* Keep the protection line in sync: auto-add by default, remove when the cart has nothing else */
  function sync(cart) {
    renderProt(cart);
    if (!protId || syncing) return;
    var shown = cart.item_count - protQty(cart);
    var line = 0, qty = 0;
    cart.items.forEach(function (it, i) { if (isProt(it)) { line = i + 1; qty = it.quantity; } });
    var job = null;
    if (!shown && qty) job = changeLine(line, 0);
    else if (shown && qty > 1) job = changeLine(line, 1);
    else if (shown && !qty && protDefault && !protOff()) job = addItems([{ id: +protId, quantity: 1 }]).then(fetchCart);
    if (!job) return;
    syncing = true;
    job.then(function (c) { return c && c.items ? c : fetchCart(); })
      .then(function (c) { syncing = false; render(c); })
      .catch(function () { syncing = false; });
  }

  cartEl.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-lp-prot-cb]');
    if (!cb || !lastCart) return;
    var row = cb.closest('[data-lp-prot]'); if (row) row.setAttribute('aria-busy', 'true');
    syncing = true;
    var job;
    if (cb.checked) {
      setProtOff(false);
      job = addItems([{ id: +protId, quantity: 1 }]).then(fetchCart);
    } else {
      setProtOff(true);
      var line = 0;
      lastCart.items.forEach(function (it, i) { if (isProt(it)) line = i + 1; });
      job = line ? changeLine(line, 0).then(function (c) { return c && c.items ? c : fetchCart(); }) : fetchCart();
    }
    job.then(function (c) { syncing = false; render(c); }).catch(function () { syncing = false; fetchCart().then(render); });
  });

  cartEl.addEventListener('click', function (e) {
    var q = e.target.closest('[data-lp-q]');
    if (q && lastCart) {
      var line = +q.dataset.lpQ, d = +q.dataset.d, it = lastCart.items[line - 1];
      if (!it) return;
      var row = q.closest('.lp-cart__item'); if (row) row.setAttribute('aria-busy', 'true');
      changeLine(line, d === 0 ? 0 : Math.max(0, it.quantity + d)).then(render);
      return;
    }
    if (e.target.closest('[data-lp-up-add]')) {
      addItems([{ id: +cartEl.dataset.upsellId, quantity: 1 }]).then(fetchCart).then(render);
      return;
    }
    if (e.target.closest('[data-lp-cart-close]')) close();
  });

  function open(cart) {
    var p = cart ? Promise.resolve(cart) : fetchCart();
    return p.then(function (c) {
      render(c);
      cartEl.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var x = cartEl.querySelector('.lp-cart__x'); if (x) x.focus({ preventScroll: true });
    });
  }
  function close() {
    cartEl.hidden = true;
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !cartEl.hidden) close(); });

  /* Header cart icon → this cart (instead of the theme's default drawer / cart page) */
  window.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"], a.action__cart, a[href$="/cart"]');
    if (!t || cartEl.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  window.LPCart = { open: open, close: close, add: addItems, refresh: function () { return fetchCart().then(render); } };
})();
